// COMPONENTS...
import { LayoutAuth } from '../../../../components/Layout/LayoutAuth';
import { Fieldset, Input } from '../../../../components/Form/Form';
import { Button } from '../../../../components/Button/Button';

// STYLES...
import { FormItem, Label } from '../../../../components/Form/FormStyled';

export function ResetAdmin() {
    return (
        <LayoutAuth
            title="Altere sua senha"
            returnText="home"
            returnTo="/"
            notHave="Lembrou a senha?"
            notHaveText="Logar"
            notHaveTo="/auth/admin/login"
        >
            <form className="formAuth" id="formLogin">
                <Fieldset
                    toTheForm="formAuthReset"
                    name="Reset"
                    title="Reset"
                >

                    <FormItem>
                        <Label htmlFor="name"> Nome </Label>
                        <Input
                            disabled
                            id="name"
                            type="text"
                            placeholder="Informe o nome"
                        />
                    </FormItem>

                    <FormItem>
                        <Label htmlFor="password"> Password </Label>
                        <Input
                            id="password"
                            type="password"
                            placeholder="Informe o password"
                        />
                    </FormItem>

                    <FormItem>
                        <Label htmlFor="password-confirm"> Confirme password </Label>
                        <Input
                            id="password-confirm"
                            type="password"
                            placeholder="Confirme o password"
                        />
                    </FormItem>
                </Fieldset>

                <Button isFull type="submit"> Salvar </Button>
            </form>
        </LayoutAuth>
    );
}